const initialAuthState = {
	loggedin: false,
	tags: null,
	roles: [],
	modules: {},
	menu: {},
	license: { products: [], routes: [], baseRoute: '/' }
};
const auth = (state = initialAuthState, action) => {
	switch (action.type) {
		case 'AUTH_SET_TAGS':
			return {
				...state,
				tags: action.tags || null,
				loggedin: Boolean(action.tags)
			};
		case 'AUTH_SET_ROLES':
			return {
				...state,
				roles: Array.isArray(action.roles) ? action.roles : []
			};
		case 'AUTH_SET_LICENSE':
			return {
				...state,
				license: { ...state.license, ...action.license }
			};
		case 'AUTH_SET_MODULES':
			return {
				...state,
				modules: action.modules || {}
			};
		case 'AUTH_SET_MENU':
			return {
				...state,
				menu: action.menu || {}
			};
		case 'AUTH_SET':
			return {
				...state,
				...action.auth
			};
		case 'AUTH_SET_LOGGED_IN':
			return {
				...state,
				loggedin: action.loggedin
			};
		case 'AUTH_UNSET':
			return initialAuthState;
		default:
			return state;
	}
};
export default auth;